export enum PhoneType {
  DEFAULT,
  DDI,
  MOBILE,
  FAX,
  OFFICE
}

export interface PhoneNumber {
  countryCode: string,
  areaCode: string,
  number: string,
  type: PhoneType
}